import { Icon20PictureOutline } from '@vkontakte/icons';
import { Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import sharedAlbumsImage from 'img/family-content/empty-block-albums-sharing.png';
import sharedAlbumsImageDark from 'img/family-content/empty-block-albums-sharing-dark.png';
import { xray } from 'lib/xray';
import React, { type ReactElement } from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import styles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';

export const SharedAlbums = (): ReactElement => {
    const onClick = (): void => {
        xray.send('empty_family-album_create', { p: 'cloud' });
        toolbarActions.create('familyAlbum', 'emptyState', undefined, '', true, true);
    };

    return (
        <div className={styles.card} onClick={onClick} data-qa-id="family-shared-albums">
            <div className={styles.icon}>
                <Icon20PictureOutline data-qa-id="family-shared-albums-icon" />
            </div>
            <Spacing size={24} style={{ pointerEvents: 'none' }} />
            <Title level="2" data-qa-id="family-shared-albums-title">
                Создайте семейный альбом
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-shared-albums-content">Он будет общим для всех участников семейной подписки</Text>
            <img
                src={isDarkTheme ? sharedAlbumsImageDark : sharedAlbumsImage}
                alt="Общие альбомы"
                className={classNames(styles.image, styles.albumsImage)}
                data-qa-id="family-shared-albums-image"
            />
        </div>
    );
};
